<template>
    <div class="b-color-picker">
        <div class="color-thumbnail" :style="{'background-color':this.hex8}" @click="showPicker"/>
        <div id="picker" @blur="inFocus=false" >
            <color-picker v-if="show & isSimplePallete" class="modal" :value="hex8" @input="updateValue" />
            <color-picker-adv v-else-if="show" class="modal-adv" :value="hex8" @input="updateValue" />
        </div>
    </div>
</template>

<script>
import { UIUpdate } from '../../lib/bezieLib/UI/UIUpdate';
import { Swatches, Sketch } from 'vue-color'
import { ColourUtils } from '../../lib/bezieLib/Colour/ColourUtils';
import { isSimplePallete } from '../../lib/bezieLib/UI/UIUpdate';

export default {
  name: 'BColorPicker',
  props: ['setColor'],
  components: {
      'color-picker': Swatches,
      'color-picker-adv': Sketch
  },
  data: function(){
        return{
            show: false,
            //selectedColor: '#333',
            hex8: '',
            isSimplePallete: true,
            inFocus: false
        }
  },
  watch: {
      setColor: function(val){
          if(this.setColor._rgba){
            this.hex8 = '#'+ColourUtils.rgbaToHex(this.setColor._rgba, true);
            //console.log('bpicker, setting color val:['+this.setColor+'] hex:['+this.hex8+']');
          }
      }
  },
  methods: {
      updateValue: function(val){
          //console.log("new value: "+val.hsv.h+";"+val.hsv.s+";"+val.hsv.v);
          this.$emit('input', val);
      },
      showPicker: function(event){
          if(this.show){
            this.show = false;
          }else{
            this.isSimplePallete = UIUpdate.isSimplePallete();
            this.show = true;
            this.inFocus = true;
            document.addEventListener("mouseup", this.onMouseClickUp);
          }
      },
      onMouseClickUp: function(event){
          if(this.show && !this.inFocus){
              this.show = false;
              document.removeEventListener("mouseup", this.onMouseClickUp);
          }
      }
  }
}
</script>

<style scoped>
.color-thumbnail{
    width: 32px;
    height: 32px;
    border-radius: 16px;
    vertical-align: top;
    cursor: pointer;
}

.color-thumbnail:hover{
    opacity: 0.75;
}

.modal{
    position: fixed;
    z-index: 6;
    width: 474px;
    height: auto;
    overflow-y: overlay;
}

.modal-adv{
    position: fixed;
    z-index: 6;
    width: 300px;
    height: auto;
}
</style>
